import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function SalesHRA() {
  return (
    <>
      <div>
        <TableList Role="Sales-HRA" />
      </div>
    </>
  );
}
